var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('f-model',{attrs:{"width":"1200px","visible":_vm.imgprivew.visible,"closeoutsize":true},on:{"close":_vm.close}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('img',{attrs:{"width":"100%","src":_vm.imgprivew.src}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3f3a323a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/imgprivew/index.vue
// module id = null
// module chunks = 